// extracted by mini-css-extract-plugin
module.exports = {"socialCard":"GridCard_socialCard__3NjAr","content":"GridCard_content__2mhCQ"};